import React from 'react';

import { Field, Image, ImageField, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentWithContextProps, SitecoreContextValue } from 'lib/ComponentProps';

import styles from './PageTitle.module.css';

type PageTitleContext = ComponentWithContextProps & {
	fields: {
		Logo?: ImageField;
		Title: Field<string>;
		Subtitle?: Field<string>;
		PageTitle: Field<string>;
		PageSubtitle: Field<string>;
	};
};

export default function PageTitle(props: PageTitleContext): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<PageTitleContext & SitecoreContextValue>();

	const pageTitleField = props.fields?.Title?.value ? props.fields.Title : props.fields?.PageTitle;

	const subTitleField = props.fields?.Subtitle?.value ? props.fields.Subtitle : props.fields?.PageSubtitle;

	return (
		<header className={`${styles.header} maxWidth pad`} data-display-pdf-download>
			<Image media={props.fields?.Logo} className={styles.logo} />

			<div>
				{!pageTitleField && sitecoreContext.wildcardMetaData?.pageTitle && (
					<Text tag="h1" field={{ value: sitecoreContext.wildcardMetaData?.pageTitle }} className={styles.title} />
				)}
				{pageTitleField && <Text tag="h1" field={pageTitleField} className={styles.title} />}

				<Text tag="h2" field={subTitleField} className={styles.subTitle} />
			</div>
		</header>
	);
}
